<app-page-header
    [title]="selectedProcess?.name || 'Requisitos de documentos'"
    [mobileTitle]="selectedProcess?.name || 'Documentos'"
    icon="fas fa-file-signature"
    [showBack]="true"
    [hasOptions]="false"
    (back)="closeModule()">
</app-page-header>

<div class="row">
    <div class="col-12"
         [class.mobile-requests-container]="appSettings.isMobile()">
        <div class="mobile-list-shell" [class.panel]="!appSettings.isMobile()" [class.p-3]="!appSettings.isMobile()">
            @if (selectedProcess) {
                <!-- Solo desktop: en móvil el page-header ya muestra el nombre (evitar hueco por flex:1 del shell) -->
                <div class="d-none d-md-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                    <div class="d-flex align-items-center gap-2">
                        <h4 class="m-0">Requisitos para: <span class="text-primary">{{ selectedProcess.name }}</span></h4>
                        @if (selectedProcess.abbr) {
                            <span class="badge bg-primary">{{ selectedProcess.abbr }}</span>
                        }
                    </div>
                </div>

                <app-requirements-list
                    [requirements]="requirements"
                    [processSlug]="selectedProcess.slug"
                    (manageRequirements)="openManageRequirements()"
                    (syncRequirements)="syncProcessRequirements()">
                </app-requirements-list>
            } 
        </div>
    </div>
</div>
